import React from "react";
import { ToastContainer } from "react-toastify";
import { ManageAlbum } from "../components/Albums/ManageAlbum";
export const  AlbumManage= () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageAlbum />
        </div>
      </div>
    </div>
  );
};